import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="flex flex-col md:flex-row gap-10 md:gap-16">
          <div className="md:w-80">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-white">宅男视频</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              宅男视频 - 数字视频平台，提供91视频、97视频等免费高清在线观看服务，覆盖51视频网站及数字视频平台海量资源，播放流畅不缓冲。
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-white text-sm font-semibold mb-4">视频分类</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/91video" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">91视频</Link>
                <Link to="/category/97video" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">97视频</Link>
                <Link to="/category/51video" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">51视频网站</Link>
                <Link to="/category/hd" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">高清专区</Link>
              </div>
            </div>
            <div>
              <h4 className="text-white text-sm font-semibold mb-4">快捷入口</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/hot" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门推荐</Link>
                <Link to="/category/latest" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">最新上线</Link>
                <Link to="/about" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              </div>
            </div>
            <div>
              <h4 className="text-white text-sm font-semibold mb-4">关于平台</h4>
              <div className="flex flex-col gap-2.5">
                <span className="text-foreground-400 text-sm">免费高清播放</span>
                <span className="text-foreground-400 text-sm">视频不卡顿</span>
                <span className="text-foreground-400 text-sm">在线观看</span>
                <span className="text-foreground-400 text-sm">海量资源</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 宅男视频 版权所有 | 数字视频平台
          </p>
          <div className="flex items-center gap-4 text-foreground-500 text-xs">
            <span>91视频</span>
            <span>97视频</span>
            <span>51视频网站</span>
            <span>免费高清在线观看</span>
          </div>
        </div>
      </div>
    </footer>
  );
}